"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = _interopRequireDefault(require("./Icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Link = function Link(props) {
  var linkBaseClass = "lnk";

  switch (props.type) {
    case "icon":
      linkBaseClass += "-" + props.type + " " + props.iconClass;
      break;

    case "mini":
      linkBaseClass += "-" + props.type;
      break;

    default:
      break;
  }

  var classes = (0, _classnames["default"])(linkBaseClass, props.className);

  if (props.text !== null) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: props.href,
      id: props.id,
      target: props.target,
      className: classes,
      style: props.style,
      tabIndex: props.tabIndex
    }, " ", props.text, props.iconClass && /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      name: props.iconClass
    }));
  } else {
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: props.href,
      id: props.id,
      target: props.target,
      className: classes,
      style: props.style,
      tabIndex: props.tabIndex
    }, " ", props.children, props.iconClass && /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      name: props.iconClass
    }));
  }
};

Link.propTypes = {
  type: _propTypes["default"].oneOf(["mini", "icon", 'normal']),
  iconClass: _propTypes["default"].string,
  href: _propTypes["default"].string,
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  tabIndex: _propTypes["default"].number,
  id: _propTypes["default"].string,
  target: _propTypes["default"].string
};
Link.defaultProps = {
  type: "normal",
  iconClass: "",
  href: "#",
  text: null,
  className: "",
  style: {},
  tabIndex: 1,
  id: ""
};
var _default = Link;
exports["default"] = _default;